import { ColumnsType } from "antd/es/table";
import { Question, User } from "@types";
import { Translation } from "react-i18next";
import { Typography } from "antd";
import parse, { domToReact } from 'html-react-parser';
import { Search } from "lucide-react";
import { TableFilterDropdown, QuestionTableActions } from "@components";

const options = {
  replace: (domNode: any) => {
    if (domNode.name === 'p') {
      // Replace the <p> with a <span>, keeping its children
      return <span>{domToReact(domNode.children)}</span>;
    }
  },
};

export const examQuestionsTable = (groupId?: string, examPeriodScreen?: boolean): ColumnsType<Question> => {
  const columns: ColumnsType<Question> = [
    {
      title: <Translation>{t => t("table.question")}</Translation>,
      dataIndex: "text",
      key: "text",
      filterSearch: true,
      width: "60%",
      ellipsis: true,
      onFilter: (value: any, record) => record.text.toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <TableFilterDropdown
          setSelectedKeys={setSelectedKeys}
          selectedKeys={selectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          prefixCls={""}
          close={function (): void {
            throw new Error("Function not implemented.");
          }}
          visible={true}
        />
      ),
      filterIcon: (filtered: boolean) => (
        <Search style={{ color: filtered ? "#F1B80E" : undefined }} />
      ),
      render(value: string) {
        return <Typography.Text>{parse(value, options)}</Typography.Text>;
      },
    },
    {
      title: <Translation>{t => t("table.author")}</Translation>,
      dataIndex: "user",
      key: "user",
      render(value: User) {
        return (value?.firstName || "") + " " + (value?.lastName || "");
      },
    },
  ];

  // Conditionally add the actions column if groupId is provided
  if (groupId) {
    columns.push({
      title: <Translation>{t => t("table.actions")}</Translation>,
      key: "actions",
      render(_, record) {
        return (
          <QuestionTableActions
            groupId={groupId}
            question={record}
            examPeriodScreen={examPeriodScreen}
          />
        );
      },
    });
  }

  return columns;
};